<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索荣誉" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import {searchHonor } from '@/api/ballsports/base/honor';

export default {
    name: "honor-search",
    components: {
        basicSearch
    },
    data () {
        let self = (window.x = this)
        return {
            onSearchApi: searchHonor,
        }
    }
}
</script>